import { gql } from "@apollo/client";
import Field from "controls/Field";
import Form, { FormSubmitButton } from "controls/Form";
import { useActionFragment } from "hooks/useAction";
import useData from "hooks/useData";
import useShowMessage from "hooks/useShowMessage";
import SwitchInput from "inputs/SwitchInput";
import React, { useEffect, useState } from "react";

import PublicForm from "./PublicForm";

export default function UnsubscribePage() {
  const [disableAllNotifications, disableAllNotificationsSet] = useState(false);
  const [subscribedCompetitions, subscribedCompetitionsSet] = useState(true);
  const [subscribedNotifications, subscribedNotificationsSet] = useState(true);
  const [subscribedMarketing, subscribedMarketingSet] = useState(true);

  const unsubscribeToken = window.location.search.match(/token=([^&]+)/)?.[1];
  const [data, dataMeta] = useData(
    gql`
      query UnsubscribePage($unsubscribeToken: String!) {
        userUnsubscribeStatus(unsubscribeToken: $unsubscribeToken) {
          subscribedNotifications
          subscribedCompetitions
          subscribedMarketing
        }
      }
    `,
    { unsubscribeToken },
  );

  useEffect(() => {
    if (data?.userUnsubscribeStatus) {
      subscribedNotificationsSet(data.userUnsubscribeStatus.subscribedNotifications);
      subscribedCompetitionsSet(data.userUnsubscribeStatus.subscribedCompetitions);
      subscribedMarketingSet(data.userUnsubscribeStatus.subscribedMarketing);
    }
  }, [data]);

  useEffect(() => {
    if (disableAllNotifications) {
      subscribedNotificationsSet(false);
      subscribedCompetitionsSet(false);
      subscribedMarketingSet(false);
    }
  }, [disableAllNotifications]);

  useEffect(() => {
    if (subscribedNotifications || subscribedCompetitions || subscribedMarketing) {
      disableAllNotificationsSet(false);
    }
  }, [subscribedNotifications, subscribedCompetitions, subscribedMarketing]);

  const userUnsubscribeEmails = useActionFragment("userUnsubscribeEmails");
  const showMessage = useShowMessage();

  return (
    <PublicForm
      dense
      loading={dataMeta.loading}
      title="Email Preferences"
      paperProps={{
        component: Form,
        onSubmit: async (formData) => {
          await userUnsubscribeEmails({
            input: { unsubscribeToken, ...formData },
          });
          showMessage("Your email preferences have been updated.", { modal: true });
        },
      }}
    >
      <Field
        name="subscribedNotifications"
        value={subscribedNotifications}
        onChange={subscribedNotificationsSet}
        label="Receive Game Notifications"
        input={<SwitchInput />}
      />
      <Field
        name="subscribedCompetitions"
        value={subscribedCompetitions}
        onChange={subscribedCompetitionsSet}
        label="Receive Plays of the Week Notifications"
        input={<SwitchInput />}
      />
      <Field
        name="subscribedMarketing"
        value={subscribedMarketing}
        onChange={subscribedMarketingSet}
        defaultValue={data?.userUnsubscribeStatus?.subscribedMarketing}
        label="Receive Marketing Notifications"
        input={<SwitchInput />}
      />
      <SwitchInput
        label="Disable All Notifications"
        value={disableAllNotifications}
        onChange={disableAllNotificationsSet}
      />
      <FormSubmitButton content="Save Preferences" />
    </PublicForm>
  );
}
